import { Box } from '@factorialco/deprecated-design-system'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import AutoScheduleButton from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/ShiftActionsBar/AutoScheduleButton'
import Publish from 'modules/shift_management/components/ShiftManagement/Layout/Actions/Publish'
import { Separator } from 'modules/shift_management/components/ShiftManagement/Separator'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'

import AddShiftButton from './AddShiftButton'
import ClearSelectionButton from './ClearSelectionButton'
import CopyPeriodButton from './CopyPeriodButton'
import CopyShiftButton from './CopyShiftButton'
import DeleteButton from './DeleteButton'
import EditShiftsButton from './EditShiftButton'
import ShowCoverageSectionButton from './ShowCoverageSectionButton'

interface Props {
  hasNoneShiftManagementPlanning?: boolean
  disabled?: boolean
  setShowCoverageSection: (showCoverageSection: boolean) => void
  showCoverageSection?: boolean
  hasTimeOffModule: boolean
}

const ShiftActionsBar = ({
  hasNoneShiftManagementPlanning,
  disabled,
  setShowCoverageSection,
  showCoverageSection,
  hasTimeOffModule,
}: Props) => {
  const [{ view }] = useSchedule()
  const { isEnabled: isSelectionEnabled, shifts: selectedShifts } = useSelectionState()
  const [{ canUseCoverageView, canUseCopySchedulePeriod, hasFeatureFlag }] = useEnabledFeatures()

  const showCoverageSectionButton = view.isByEmployees && view.isWeekly
  const shifts = Object.values(selectedShifts)

  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s8"
      justifyContent="flexEnd"
      style={{
        flexGrow: '1',
        flexBasis: '0px',
      }}
    >
      {showCoverageSectionButton && !newEntryFlowEnabled && (
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Separator />
          <ShowCoverageSectionButton
            setShowCoverageSection={setShowCoverageSection}
            showCoverageSection={showCoverageSection}
            hasNoneShiftManagementPlanning={disabled}
            hasCoverageView={canUseCoverageView}
          />
        </Box>
      )}
      {!isSelectionEnabled && view.isWeekly && !canUseCopySchedulePeriod && (
        <CopyShiftButton disabled={hasNoneShiftManagementPlanning} />
      )}
      {isSelectionEnabled && !isEmpty(shifts) && <EditShiftsButton />}
      {isSelectionEnabled && <ClearSelectionButton />}
      {isSelectionEnabled && newEntryFlowEnabled && <Separator />}
      <AddShiftButton
        disabled={hasNoneShiftManagementPlanning}
        hasTimeOffModule={hasTimeOffModule}
      />
      {canUseCopySchedulePeriod && <CopyPeriodButton disabled={hasNoneShiftManagementPlanning} />}
      <DeleteButton disabled={hasNoneShiftManagementPlanning} />
      <Separator />
      <AutoScheduleButton />
      <Publish />
    </Box>
  )
}

export default observer(ShiftActionsBar)
